import { render, staticRenderFns } from "./OnePage.vue?vue&type=template&id=78e9903a&scoped=true&"
import script from "./OnePage.vue?vue&type=script&lang=ts&"
export * from "./OnePage.vue?vue&type=script&lang=ts&"
import style0 from "./OnePage.vue?vue&type=style&index=0&id=78e9903a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e9903a",
  null
  
)

export default component.exports